import React from 'react';
import { Link } from "react-router-dom";

const navbarLinks = [
  { name: "Home", link: "/", id: 1 },
  { name: "Dashboard", link: "/login", id: 2 },
  { name: "Plans", link: "/plans", id: 3 },
  { name: "Solutions", link: "/solutions", id: 4 },
  { name: "Contact Us", link: "/contact", id: 5 },
];

const ResponsiveMenu = ({ showMenu, setShowMenu }) => {
  // const handleHomeClick = () => {
  //   window.scrollTo(0, 0);
  //   window.location.href = "/";
  //   setShowMenu(false);
  // };

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
    setShowMenu(false);
  };

  return (
    <>
      {/* Internal CSS */}
      <style>{`
        .custom-space-y > :not([hidden]) ~ :not([hidden]) {
          margin-top: 2rem; /* Tailwind's space-y-6 */
        }

        @media (max-width: 359px) {
          .custom-space-y > :not([hidden]) ~ :not([hidden]) {
            margin-top: 1rem; /* Tailwind's space-y-2 */
          }
        }
      `}</style>

      <div
        className={`
          ${showMenu ? "right-0" : "-right-[100%]"} fixed bottom-0 top-12 z-20 flex w-[48%] md:w-[36%]
          h-[56%] md:hidden rounded-l-xl bg-[#000300]/80 px-8 pt-6
          transition-all duration-200 shadow-md sm:w-[30%] xs:w-[30%]
        `}
      >
        <div className="flex items-center justify-center h-full w-full">
          <div className="w-full">
            <div className="text-white">
              <ul className="flex flex-col items-start justify-center h-full custom-space-y pt-3">
                {navbarLinks.map(({ name, link, id }) => (
                  <li key={id}>
                    <Link
                      to={link}
                       onClick={() => window.scrollTo(0, 0)}
                      // onClick={name === "Home" ? handleHomeClick : handleLinkClick}
                      className="inline-block text-white text-md font-bold hover:text-gray-300 transition-colors front-side"
                    >
                      {name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResponsiveMenu;